<template>
  <div v-loading="showFlag">
    <t-form
      ref="userCustomersForm"
      name="userCustomersForm"
      label-position="right"
      label-width="120px"
      domain="userCustomersorm"
    >
      <t-table
        :data="customersList"
        tooltip-effect="dark"
        style="width: 100%"
        header-cell-class-name="bg-default"
        :max-height="maxheight"
        highlight-current-row
        border
      >
        <t-table-column
          v-if="userList.length"
          width="200"
          prop="cusName"
          class-name="cell_txt_center"
          :label="$t('resource.CUS_M_ORDER_AMOUNT.CUS_NAME')"
        ></t-table-column>

        <t-table-column
          v-for="(column, index) in userList"
          :key="index"
          :label="column.userName"
          min-width="100"
          class-name="cell_txt_center"
          ><template #default="scope">
            <t-checkbox
              :ref="'checkRef' + scope.$index + '_' + index"
              :checked="IsCheckUserCustomers(column.userId, scope.row.cusCode)"
            ></t-checkbox>
          </template>
        </t-table-column>
      </t-table>

      <t-row type="flex" justify="end">
        <div style="height: 60px">
          <t-col :span="24" style="padding-right: 20px; padding-top: 10px">
            <t-button
              type="primary"
              style="width: 100px; height: 40px"
              @click="Confirm"
              >{{ $t("resource.sys.sure") }}</t-button
            >
          </t-col>
        </div>
      </t-row>
    </t-form>
  </div>
</template>
<script>
import { t } from "@/locales";
import {
  SearchUserCustomer,
  UpdateUserCustomer,
} from "@/services/userCustomerInfo";
import { Message } from "@tellus/component";

export default {
  data() {
    return {
      //一覧高
      maxheight: window.innerHeight - 50,
      //担当者(ユーザー)リスト
      userList: [],
      //得意先リスト
      customersList: [],
      //担当得意先情報リスト
      userCustomersList: [],
      userCustomersOutList: [
        {
          ucUserId: "",
          ucCusCode: "",
          ucManagerKbn: "",
        },
      ],
      //待ち表示フラグ
      showFlag: false,
    };
  },

  computed: {},

  mounted() {
    this.Init();

    this.$nextTick(() => {
      this.maxheight = document.body.clientHeight - 50;
    });
  },

  computed: {},

  methods: {
    // 初期化
    Init() {
      this.showFlag = true;
      this.SearchUserCustomer();
    },

    // 検索
    SearchUserCustomer() {
      SearchUserCustomer({
        selectUserId: "",
      })
        .then((res) => {
          //担当者(ユーザー)リスト
          this.userList = res.userList;
          //得意先リスト
          this.customersList = res.customersList;
          //担当得意先情報リスト
          this.userCustomersList = res.userCustomersList;
          this.showFlag = false;
        })
        .catch((err) => {
          this.showFlag = false;
          Message.showError(t("message.USER_CUSTOMER.INIT_FAILURE"));
        });
    },

    // 編集
    Confirm() {
      this.showFlag = true;
      //担当得意先のクリア
      this.userCustomersOutList.length = 0;
      //得意先の繰り返し
      for (let rowNum = 0; rowNum < this.customersList.length; rowNum++) {
        //担当者の繰り返し
        for (let colNum = 0; colNum < this.userList.length; colNum++) {
          //選択
          if (this.$refs["checkRef" + rowNum + "_" + colNum][0].isChecked) {
            //選択した担当得意先
            this.userCustomersOutList.push({
              //ユーザーID
              ucUserId: this.userList[colNum].userId,
              //得意先コード
              ucCusCode: this.customersList[rowNum].cusCode,
              //管理区分
              ucManagerKbn: "1",
              //更新者
              ucUpdateUser: localStorage.getItem("useId"),
            });
          }
        }
      }

      // console.log(
      //   "this.userCustomersList---" + JSON.stringify(this.userCustomersOutList)
      // );

      UpdateUserCustomer({
        selectUserId: "",
        userCustomersList: this.userCustomersOutList,
      })
        .then((res) => {
          // console.log("showSuccess");
          this.showFlag = false;
          Message.showSuccess(t("message.USER_CUSTOMER.ADD_SUCCESS"));
        })
        .catch((err) => {
          this.showFlag = false;
          // console.log("showError");
          Message.showError(t("message.USER_CUSTOMER.ADD_FAILURE"));
        });
    },

    // 担当得意先情報チェックの判断
    IsCheckUserCustomers(userId, cusCode) {
      for (let index = 0; index < this.userCustomersList.length; index++) {
        const element = this.userCustomersList[index];
        if (element.ucUserId == userId && element.ucCusCode == cusCode) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>
